import React from 'react';
import Button from '@atlaskit/button';
import { FormFooter, FormHeader } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';
import { CopyableField, Divider } from '@css-xp/base';
import { useSidebar } from '@css-xp/base/hooks/src/use-sidebar';

interface Props {
  creditRequestAppLink: string;
}

export const GenerateNet30PaymentTerms = ({ creditRequestAppLink }: Props) => {
  const { closeSidebar } = useSidebar();
  return (
    <div style={{ maxWidth: '600px', padding: '25px' }}>
      <FormHeader title={'Net-30 payment terms application'} />
      <br />
      <SectionMessage appearance="information" title="Payment terms application form">
        The customer needs to apply for payment terms. Copy the application link and share it with the customer via GSAC
        ticket.
      </SectionMessage>
      <CopyableField
        autoSelect={false}
        value={`${creditRequestAppLink}`}
        label="Application link"
        testId="copy-field-gsac-link"
      />
      <br />
      <Divider />
      <FormFooter align="end">
        <Button appearance="primary" onClick={closeSidebar} testId="close-button">
          Close
        </Button>
      </FormFooter>
    </div>
  );
};
